// authSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  user: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      //   console.log("thisistheload", action.payload);
      state.isAuthenticated = true;
      state.user = action.payload.user;

      const tokenWithPrefix = `Bearer ${action.payload.token}`;
      sessionStorage.setItem("token", tokenWithPrefix);
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      sessionStorage.removeItem("token");
    },
    profileupload: (state, action) => {
      state.user = action.payload.user;
    },
  },
});

export const { loginSuccess, logout, profileupload } = authSlice.actions;
export default authSlice.reducer;
